exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@charset \"UTF-8\";\n.calendar-day {\n  text-align: center;\n  color: #202535;\n  line-height: 30px;\n  font-size: 12px;\n}\n.is-selected {\n  color: #f8a535;\n  font-size: 10px;\n  margin-top: 5px;\n}\n#calendar .el-button-group > .el-button:not(:first-child):not(:last-child):after {\n  content: \"\\5F53\\6708\";\n}", ""]);

// exports
